import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import OrganisationLayout from "../layout/OrganisationLayout";
import { performLogout } from "../../Util/logoutHelper";
import {
  getOrganisationRoleAccess,
  getActiveGroup,
  getOrganisationGroupRole,
  formatOrganisationRole,
} from "../utils/roleAccess";
import ConfirmModal from "../../modals/ConfirmModal";

const getProfileImage = (member) =>
  member?.profileImage ||
  member?.image ||
  member?.avatar ||
  member?.profile ||
  "";

export default function OrganisationGroupsSettings() {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state?.authSlice.userData?.payload);
  const organisationGroup = getActiveGroup(userData);
  const access = getOrganisationRoleAccess(userData);
  const profileImage = getProfileImage(userData);

  const [isModalOpen, setModalOpen] = useState(false);
  const handleConfirmClose = () => setModalOpen(false);

  const logoutFunc = async () => {
    await performLogout(dispatch, userData);
  };

  return (
    <OrganisationLayout>
      <Container fluid className="mt-5">
        <Row className="justify-content-center ">
          <Col xxl={5} xl={6} lg={10} className="mt-4">
            {" "}
            <div className="cmn-card-color mt-4 pb-4 pt-4">
              <div className="student-view">
                <img
                  src={profileImage || require("../../Assets/Images/girl.png")}
                  alt="Organisation profile"
                />
                <h2>
                  {[userData?.firstName, userData?.surName]
                    .filter(Boolean)
                    .join(" ") || "Organisation Group User"}
                </h2>
                <p>{organisationGroup?.name || "Organisation Group Module"}</p>
                <p>
                  {formatOrganisationRole(getOrganisationGroupRole(userData))}
                </p>

                {userData?.role === "School" && (
                  <Link to="/school-profile" className="cmn-pink w-50 mb-3 mt-4">
                    School Details
                  </Link>
                )}

                {access.isGroupUser && (
                  <Link to="/organisations/org-group-details" className="cmn-pink w-50 mb-3 mt-4">
                    Org Group Details
                  </Link>
                )}

                {access.hasMemberAccess && (
                  <Link to="/likes" className="cmn-pink w-50 mb-3">
                    Likes
                  </Link>
                )}

                <Link to="/organisations/update-password" className="cmn-pink w-50 mb-3">
                  Update Password
                </Link>

                <Link
                  to="https://peerscroller.com/legal"
                  className="cmn-pink w-50 mb-3"
                  target="_blank"
                >
                  Legal
                </Link>

                <button
                  onClick={() => setModalOpen(true)}
                  className="cmn-pink w-50 mb-3 mt-3"
                >
                  Logout
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <ConfirmModal
        isModalOpen={isModalOpen}
        handleConfirmClose={handleConfirmClose}
        selectedType="logout"
        extraFunction={logoutFunc}
      />
    </OrganisationLayout>
  );
}
